import { Component, OnInit, Input } from '@angular/core';

@Component( {
    selector: 'ridango-block-full-width',
    templateUrl: './block-full-width.component.html',
    styleUrls: [ './block-full-width.component.scss' ]
} )
export class BlockFullWidthComponent implements OnInit {
    @Input() isEmpty = false;
    @Input() secondaryColor = false;
    @Input() removeMargin = false;
    @Input() secondaryBlockBackGroundV2 = false;
    @Input() removePadding = false;
    constructor() { }

    ngOnInit () {
    }

}
